module.exports = __webpack_public_path__ + "static/Repair-Complete-7df9fdfa59495dc92c463eff742210e6.svg";